import axios from 'axios';

function apiOrigin () {
  const configured = process.env.BASE_URI || '/api/';
  if (/^https?:\/\//i.test(configured)) {
    const match = configured.match(/^(https?:\/\/[^/]+)/i);
    if (match) return match[1];
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
}

function endpoint (path) {
  return `${apiOrigin()}/v1/edge-gateways${path || ''}`;
}

export default {
  namespaced: true,
  state: {
    gateways: [],
    commands: [],
    selectedGatewayId: '',
    loading: false,
    commandLoading: false
  },
  getters: {
    gateways: state => state.gateways,
    commands: state => state.commands,
    selectedGatewayId: state => state.selectedGatewayId,
    onlineCount: state => state.gateways.filter(item => item.online).length
  },
  mutations: {
    SET_LOADING (state, value) { state.loading = value; },
    SET_COMMAND_LOADING (state, value) { state.commandLoading = value; },
    SET_GATEWAYS (state, value) { state.gateways = Array.isArray(value) ? value : []; },
    SET_COMMANDS (state, value) { state.commands = Array.isArray(value) ? value : []; },
    SET_SELECTED_GATEWAY (state, value) { state.selectedGatewayId = value || ''; }
  },
  actions: {
    FETCH_GATEWAYS ({ commit }) {
      commit('SET_LOADING', true);
      return axios.get(endpoint(''), { params: { limit: 500 } })
        .then(data => {
          commit('SET_GATEWAYS', data && data.gateways);
          return data;
        })
        .finally(() => commit('SET_LOADING', false));
    },
    CREATE_GATEWAY ({ dispatch }, payload) {
      return axios.post(endpoint(''), payload).then(data => {
        return dispatch('FETCH_GATEWAYS').then(() => data);
      });
    },
    FETCH_COMMANDS ({ commit }, gatewayId) {
      commit('SET_SELECTED_GATEWAY', gatewayId);
      commit('SET_COMMAND_LOADING', true);
      return axios.get(endpoint(`/${encodeURIComponent(gatewayId)}/commands`), { params: { limit: 100 } })
        .then(data => {
          commit('SET_COMMANDS', data && data.commands);
          return data;
        })
        .finally(() => commit('SET_COMMAND_LOADING', false));
    },
    DISPATCH_COMMAND ({ dispatch }, payload) {
      const gatewayId = payload.gatewayId;
      return axios.post(endpoint(`/${encodeURIComponent(gatewayId)}/commands`), payload.command)
        .then(data => dispatch('FETCH_COMMANDS', gatewayId).then(() => data));
    },
    ROTATE_CREDENTIALS ({ dispatch }, payload) {
      return axios.post(endpoint(`/${encodeURIComponent(payload.gatewayId)}/credentials/rotate`), {
        clientCertificateFingerprint: payload.clientCertificateFingerprint
      }).then(data => dispatch('FETCH_GATEWAYS').then(() => data));
    },
    REVOKE_GATEWAY ({ dispatch }, gatewayId) {
      return axios.delete(endpoint(`/${encodeURIComponent(gatewayId)}`))
        .then(data => dispatch('FETCH_GATEWAYS').then(() => data));
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/neuronRemote.js